import { ParsedToken } from 'firebase/auth';
import { UserRoleType, userRolesByApp } from '@assets/types/UserRole.type';

function rolesOf(claims: ParsedToken): string[] {
  const claimRoles: unknown = (claims as { roles?: unknown }).roles;
  return Array.isArray(claimRoles) ? claimRoles : [];
}

export function hasAnyRole(claims: ParsedToken, roles: UserRoleType[]): boolean {
  const claimRoles: string[] = rolesOf(claims);
  return roles.some((role: UserRoleType) => claimRoles.includes(role));
}

export function hasBusinessAdminRole(claims: ParsedToken): boolean {
  return hasAnyRole(claims, ['BUSINESS_ADMIN']);
}

export function hasMerchantNetworkAdminRole(claims: ParsedToken): boolean {
  return hasAnyRole(claims, ['MERCHANT_NETWORK_ADMIN']);
}

export function hasWebBusinessAccess(claims: ParsedToken): boolean {
  const roles: string[] = rolesOf(claims);
  return userRolesByApp.webBusiness.some((allowedRole: string) => roles.includes(allowedRole));
}
